import restArguments from "./restArguments.js";
import uniq from "./uniq.js";
import flatten from "./_flatten.js";
export default restArguments(function(arrays) {
  return uniq(flatten(arrays, true, true));
});
